export const internalEventsList = [
  {
    event: "MemberAchievementProgressWasChanged",
    name: "achievementProgressed",
  },
  {
    event: "MemberAddressChanged",
    name: "memberAddressChanged",
  },
  {
    event: "MemberCompanyDetailsChanged",
    name: "memberCompanyDetailsChanged",
  },
  {
    event: "MemberDetailsChanged",
    name: "memberDetailsChanged",
  },
  {
    event: "MemberTierChanged",
    name: "memberTierChanged",
  },
  {
    event: "MemberWasActivated",
    name: "memberWasActivated",
  },
];

export type InternalEvent =
  | "MemberAchievementProgressWasChanged"
  | "MemberAddressChanged"
  | "MemberCompanyDetailsChanged"
  | "MemberDetailsChanged"
  | "MemberTierChanged"
  | "MemberWasActivated";
